import { ThankYouThumbProps as Props } from './types'

import './thankYouThumb.scss'

const ThankYouThumb = ({ alt = '', src }: Props) => (
  <div className="thank-you-thumb">
    <div className="thumb-container">
      <img alt={alt} src={src} />
    </div>
  </div>
)

export default ThankYouThumb
